import { render, staticRenderFns } from "./OrangeButton.vue?vue&type=template&id=1d7f1c78&scoped=true"
import script from "./OrangeButton.vue?vue&type=script&lang=js"
export * from "./OrangeButton.vue?vue&type=script&lang=js"
import style0 from "./OrangeButton.vue?vue&type=style&index=0&id=1d7f1c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f1c78",
  null
  
)

export default component.exports